import { Editor } from "@tiptap/react"
import { EditorMatch } from "../../model/languagetool/types"
import { MatchesRepository } from "../../model/languagetool/MatchesRepository"
import { FORCE_REFRESH_MATCHES, REFRESH_MATCHES, SKIP_PROCESSING } from "../../extensions/softcatala"
import { Alternative } from "../../model/paraphrase/types"
import { getRange } from "../../extensions/textMapper"

export const replaceSuggestion = (
    editor: Editor, 
    matchesRepository: MatchesRepository, 
    currentMatch: EditorMatch, 
    replacement: string
    ) => {
    
    if (currentMatch.range && currentMatch.segment) {
        editor.commands.setTextSelection(currentMatch.range)
        matchesRepository.update(currentMatch.segment.uuid, replacement.length)
        editor.extensionStorage.softcatala.currentMatch.clear()
        editor.commands.command(({ state, dispatch }) => {
            const newTransaction = replacement
                ? state.tr.replaceSelectionWith(editor.schema.text(replacement), true).setMeta(SKIP_PROCESSING, true)
                : state.tr.deleteSelection().setMeta(SKIP_PROCESSING, true)
            if (newTransaction && dispatch) {
                dispatch(newTransaction)
            }
            return true
        })
        //  editor.commands.focus()        
    }
}

export const replaceAlternative = (
    editor: Editor,
    alternative: Alternative
) => {
    if(alternative.text && alternative.length) {
        const range = getRange(editor.view, alternative.offset, alternative.length)
        if (range) {
            editor.commands.setTextSelection(range)
            editor.commands.command(({ state, dispatch }) => {
                const newTransaction = state.tr.replaceSelectionWith(editor.schema.text(alternative.text), true).setMeta(FORCE_REFRESH_MATCHES, true)
                if (newTransaction && dispatch) {
                    dispatch(newTransaction)
                }
                return true
            })
        }
    }
}

export const cleanSuggestion = (
    editor: Editor, 
    matchesRepository: MatchesRepository, 
    currentMatch: EditorMatch
    ) => {
    
    if (currentMatch.range && currentMatch.segment) {
        editor.commands.setTextSelection(currentMatch.range)
        matchesRepository.ignore(currentMatch.segment.uuid)
        editor.extensionStorage.softcatala.currentMatch.clear()
        editor.commands.command(({ state, dispatch }) => {

            const newTransaction = state.tr.setMeta(REFRESH_MATCHES, true)
            if (newTransaction && dispatch) {
                dispatch(newTransaction)
            }
            return true
        })
        //  editor.commands.focus()        
    }
}